<template>
  <v-container id="regular-tables-view" fluid tag="section">
    <view-intro heading="C-Cloud Users" />

    <material-card
      icon="mdi-account-group"
      icon-small
      title="User List"
      color="primary"
    >
      <div class="px-4 mb-4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          :loading="loading"
        ></v-text-field>
      </div>
      <v-data-table :headers="headers" :items="users" :search="search">
        <template v-slot:[`item.created_at`]="props">
          <span>{{ props.item.created_at | moment("from", "now") }}</span>
        </template>
      </v-data-table>
    </material-card>

    <div class="py-3" />
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Users",
  data() {
    return {
      search: "",
      users: [],
      loading: false,
      headers: [
        {
          text: "Username",
          align: "start",
          sortable: false,
          value: "username"
        },
        { text: "Email", value: "email" },
        { text: "Joined", value: "created_at" }
      ]
    };
  },
  methods: {
    async getUsers() {
      this.loading = true;
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users`;
        const userResponse = await axios.get(userUrl);
        this.users = userResponse.data;
        console.log(userResponse);
      } catch (error) {
        this.$toast.error("Something went wrong getting users");
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    const AuthToken = localStorage.getItem("AuthToken");
    if (AuthToken) {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      this.getUsers();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
